module.exports = __webpack_public_path__ + "static/2front-outsource-2-0c79f8e6127b748dd96d500a0ed55410.png";